// extracted by mini-css-extract-plugin
export var content = "_bd-3";
export var list = "_bd-4";
export var settingsContent = "_bd-7";
export var settingsPanel = "_bd-8";
export var state = "_bd-6";
export var triggerBadge = "_bd-2";
export var triggerButton = "_bd-1";
export var triggerShell = "_bd-0";
export var unreadDot = "_bd-5";